import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'

//绑定VIP卡号
export function binDingVip(data) {
    return fetch({
        url: config.WEB_USER_BINDVIPCARD_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//VIP卡号详情
export function vipCardInfo(data) {
    return fetch({
        url: config.WEB_USER_VIPCARDINFO_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}